const mutationsType = {
  UPDATE_RIGHT_SIDEBAR: 'UPDATE_RIGHT_SIDEBAR',
}
export const state = () => ({
  rightSidebar: {
    isOpenRightSideBar: false,
    componentName: '',
    props: {},
  },
  activities: [
    {
      id: 1,
      name: 'Jurrien Oldhof',
      image: 'http://placehold.jp/32x32.png',
      activity: "Started 'Segment Title 2' of Special Needs Class",
      time: '16 August at 1:12 PM',
    },
  ],
})

export const mutations = {
  [mutationsType.UPDATE_RIGHT_SIDEBAR]: (state, rightSidebar) => {
    state.rightSidebar = rightSidebar
  },
}

export const actions = {}

export const getters = {
  rightSidebar: (state) => state.rightSidebar,
  activities: (state) => state.activities,
}
